/* ==========================================================================
   Build-a-Box — Cart guard
   Mantiene la integridad de las cajas personalizadas en el carrito/drawer:
   al quitar CUALQUIER línea de un bundle (la caja o un dulce), se elimina el
   BUNDLE COMPLETO de una sola operación. Los controles por-dulce se ocultan
   vía CSS (ver el {% style %} de las plantillas del carrito), así que la
   acción normal del usuario es "quitar la caja".

   Identificación de líneas:
   - propiedad oculta _bb_bundle (id de bundle compartido por caja + sus dulces)
   - data-bb-bundle se renderiza en el <tr> para leerlo desde el DOM
   ========================================================================== */
(function () {
  'use strict';

  if (window.__bbCartGuard) return; /* evita doble registro si se incluye 2 veces */
  window.__bbCartGuard = true;

  var BKEY = '_bb_bundle';
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  /* Intercepta en CAPTURA (antes que el handler de Dawn) el clic en cualquier
     botón de quitar que esté dentro de una línea de bundle. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('cart-remove-button, .cart-remove-button');
      if (!btn) return;
      var row = btn.closest('.cart-item--bb[data-bb-bundle]');
      if (!row) return; /* no es un bundle -> deja el flujo normal de Dawn */

      e.preventDefault();
      e.stopImmediatePropagation(); /* impide que Dawn quite solo esa línea */
      removeBundle(row.getAttribute('data-bb-bundle'));
    },
    true
  );

  async function removeBundle(bundleId) {
    if (busy || !bundleId) return;
    busy = true;
    try {
      var cartRes = await fetch(routes + 'cart.js', { headers: { Accept: 'application/json' } });
      var cart = await cartRes.json();

      /* updates posicional: una entrada por línea, 0 para las del bundle */
      var updates = cart.items.map(function (it) {
        var b = it.properties && it.properties[BKEY];
        return b === bundleId ? 0 : it.quantity;
      });

      await fetch(routes + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });

      /* Recarga: re-render server-side garantizado (carrito + burbuja + drawer).
         Es una acción puntual y deliberada, así que el reload es aceptable. */
      window.location.reload();
    } catch (err) {
      console.error('[BuildABox] No se pudo quitar la caja completa:', err);
      busy = false;
    }
  }
})();
